import React from "react";
import {useNavigate} from "react-router-dom";
import ContentBox from "../../../../../components/content-box/ContentBox";
import DonationTracker from "../../../../../components/donation-tracker/DonationTracker";
import DonationInfo from "../../../../../model/DonationInfo";
import PageActions from "../../../../base/PageActions";
import useFetchResult from "../../../../../hooks/UseFetchResult";
import _http_service from "../../../../../services/HttpService";
import _image_service from "../../../../../services/ImageService";
import "../../../../styles/Common.scss";

interface KkaCharityStreamPageProps {
}

const KkaCharityStreamPage = (props: KkaCharityStreamPageProps) => {

    const page: PageActions = new PageActions({
        title: `Charity Event: Kokua Ka 'Alopeke - Chase the Fox`,
        description: `Learn more about Chase's efforts to help Hawaiians in need!`,
        keywords: ["twitch", "stream info", "chasetheredfox", "charity", "kokua ka alopeke"],
        imgSrc: `chase/assets/chase_twitch_icon.png`,
        url: `stream/charities/kka`
    });

    const navigateTo = useNavigate();

    const [getResult, hasFetchedResult, setFetchedResult] = useFetchResult<DonationInfo>(undefined,
        async () => _http_service.getDonations("kka", "2024")
            .then(response => {
                if (!response) {
                    throw new Error("Could not fetch donation data!");
                }

                return response;
            }), []);

    return page.generateMetaContent(
        <>
            <ContentBox header="I have a special place in my heart for these islands!">
                <div>
                    <img src={_image_service.getCdnImageSrc('chase/stream/charities/kka_photo.png')}
                         alt="Chase fundraising for the Hawaii Community Foundation"
                         title="The fox helps!"
                         className="width-50-percent block"/>
                    <p>
                        Kokua Ka 'Alopeke (Hawaiian for "The Fox Helps") is a charity event created by Chase to help
                        provide relief for those living in the Hawaiian islands that need it most. With the high cost
                        of living in Hawaii, it's difficult for those native to the islands to make ends meet sometimes.
                        It seems that too often Asian and Pacific Islanders who call the archipelago home are priced
                        out of their land and forced to move to the mainland United States. Things like the Covid-19
                        pandemic, the Maui wildfires, and the constant threat of beach and land erosion make it all the
                        more difficult to maintain this beautiful paradise in the world.
                    </p>
                    <p>
                        Chase started a Tiltify campaign in 2023 to help raise money for
                        the <strong>Hawaii Community Foundation</strong>, a top rated charity that provides relief to
                        the people of the islands who need it most. During these events, he tells about his experiences
                        there and explains a lot about what makes Hawaii such a magical place for him and so many
                        others. In the future, Chase may support other organizations like this, so stay tuned!
                    </p>
                    <p>
                        Please check out the website for the Hawaii Community Foundation here and consider donating
                        to their general fund or their Maui Strong Fund to aid victims of the
                        wildfires: <a href="https://www.hawaiicommunityfoundation.org/"
                                target="_blank"
                                rel="noopener noreferrer">
                            Hawaii Community Foundation website
                        </a>.
                    </p>
                    {hasFetchedResult &&
                        <DonationTracker key={`donation-tracker-kka-${Object.keys(getResult()).length}`}
                                         cause="Kokua Ka 'Alopeke 2024"
                                         donations={getResult()}/>
                    }
                </div>
            </ContentBox>
        </>
    );
}

export default KkaCharityStreamPage;